<template>
  <div>
    <div>
      <h2>六大污染物雷达图</h2>
    </div>

    <!-- <div style="text-align: left">
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <span style="color: #f56c6c"
              >什么是"人努力-天帮忙"指数？<i
                class="header-icon el-icon-info"
              ></i
            ></span>
          </template>
          <div>
            结合原始污染物浓度与气象调整后的污染物浓度，分解气象和人为因素的影响，计算“人努力—天帮忙”指数
            <br />
            用该年原始浓度与调整后浓度差值相对上一年原始浓度的比率衡量该年气象影响（“天是否帮忙”），
            <span style="color: #f56c6c">正值</span
            >表示气象条件不利，即“天不帮忙”，
            <span style="color: #409eff">负值</span
            >表示气象条件有利，即“天帮忙”；
            <br />
            用连续两年调整后浓度差值相对上一年原始浓度的比率衡量排放水平变化（“人是否努力”），
            <span style="color: #f56c6c">正值</span
            >代表背景浓度上升，即“人不努力”，
            <span style="color: #409eff">负值</span
            >代表背景浓度下降，即“人努力”。
          </div>
        </el-collapse-item>
      </el-collapse>
    </div> -->

    <div style="text-align: left; margin-top: 15px">
      <el-row>
        评估时间：
        <!-- <el-date-picker
          v-model="assessYear"
          type="year"
          placeholder="选择评估年份"
          :picker-options="pickerOptions"
          @change="assessYearChange"
          size="mini"
        ></el-date-picker> -->

        <el-select
          size="mini"
          v-model="assessYear"
          placeholder="请选择"
          @change="assessYearChange"
        >
          <el-option
            v-for="item in Years"
            :key="item"
            :label="item + '年'"
            :value="item"
          ></el-option>
        </el-select>
        <el-select
          size="mini"
          v-model="assessSeason"
          placeholder="请选择"
          @change="assessSeasonChange"
        >
          <el-option
            v-for="item in Seasons"
            :key="item.name"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-row>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div id="city-pull-radar-adm-chart-canvas">
      <el-row :gutter="4">
        <el-col :xs="24" :md="12">
          <div
            id="city-pull-radar-adm-chart"
            :style="{
              height: eleheight + 'px',
            }"
          ></div
        ></el-col>
        <el-col :xs="24" :md="12"
          ><div
            id="city-pull-radar-raw-chart"
            :style="{
              height: eleheight + 'px',
            }"
          ></div
        ></el-col>
      </el-row>
    </div>

    <!-- <div>
      <div
        id="city-hw-axis-chart"
        :style="{
          height: eleheight + 'px',
        }"
      ></div>
    </div> -->
  </div>
</template>

<style scoped>
/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
} */

.el-row {
  margin-bottom: 15px;
}
.el-divider {
  margin: 0;
  /* margin-bottom: 10px; */
}
</style>

<script>
// // @ is an alias to /src
import { getSeasonZH } from "@/assets/js/my-utils.js";

import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      eleheight: 520,
      chart: [],
      isMobile: false,
      assessPull: "PM2.5",
      assessPullContent: "h",

      assessYear: "2023",
      assessSeason: 4,
      Years: [
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
      ],

      Seasons: [
        {
          name: "春季",
          value: 1,
        },
        {
          name: "夏季",
          value: 2,
        },
        {
          name: "秋季",
          value: 3,
        },
        {
          name: "冬季",
          value: 4,
        },
        {
          name: "年均",
          value: 0,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2020 || time.getFullYear() < 2014;
        },
      },
      chart_radar_data_raw: [],
      chart_radar_data_adm: [],
      // chartName: "cityareahwheatmap",
    };
  },
  components: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById(
        "city-pull-radar-adm-chart-canvas"
      );

      let seasonZh = ["", "春季", "夏季", "秋季", "冬季"];
      let time = this.assessYear + "年" + seasonZh[this.assessSeason];

      let title = time + "污染物雷达图";

      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    getPullRadarData() {
      // 判断是否需要更新数据
      let radar_datas = [];
      const that = this;

      let url = "/AQAssess/getAreaRadar/" + this.assessYear + "/" + this.assessSeason;

      this.$axios
        .get(url)
        .then((res) => {

          for (let i = 0; i < that.assesscity.length; i++) {
            let sub_radar_data_adm = [
              that.assesscity[i][1],
              "",
              "",
              "",
              "",
              "",
              "",
            ];
            let sub_radar_data_raw = [
              that.assesscity[i][1],
              "",
              "",
              "",
              "",
              "",
              "",
            ];
            //   "PM2.5", PM10, SO2, NO2, CO, O3
            res.data.forEach((element) => {
              if (element[0] == that.assesscity[i][1]) {
                if (element[1] == "PM2.5") {
                  sub_radar_data_adm[1] = element[2];
                  sub_radar_data_raw[1] = element[3];
                } else if (element[1] == "PM10") {
                  sub_radar_data_adm[2] = element[2];
                  sub_radar_data_raw[2] = element[3];
                } else if (element[1] == "SO2") {
                  sub_radar_data_adm[3] = element[2];
                  sub_radar_data_raw[3] = element[3];
                } else if (element[1] == "NO2") {
                  sub_radar_data_adm[4] = element[2];
                  sub_radar_data_raw[4] = element[3];
                } else if (element[1] == "CO") {
                  sub_radar_data_adm[5] = element[2];
                  sub_radar_data_raw[5] = element[3];
                } else if (element[1] == "O3") {
                  sub_radar_data_adm[6] = element[2];
                  sub_radar_data_raw[6] = element[3];
                }
              }
            });

            that.chart_radar_data_raw.push(sub_radar_data_raw);
            that.chart_radar_data_adm.push(sub_radar_data_adm);

          }

          that.drawAreaPullsRadarChart(
            that.chart[0],
            that.chart_radar_data_adm,
            "气象调整后"
          );

          that.drawAreaPullsRadarChart(
            that.chart[1],
            that.chart_radar_data_raw,
            "气象调整前"
          );
        });

    },

    drawAreaPullsRadarChart(chart, data, name) {
      //   let data = [];
      let seasonZh = ["", "春季", "夏季", "秋季", "冬季"];
      let time = this.assessYear + "年" + seasonZh[this.assessSeason];
      let showdata = [];
      data.forEach((element) => {
        showdata.push({
          value: [
            parseFloat(element[1]).toFixed(2),
            parseFloat(element[2]).toFixed(2),
            parseFloat(element[3]).toFixed(2),
            parseFloat(element[4]).toFixed(2),
            parseFloat(element[5]).toFixed(2),
            parseFloat(element[6]).toFixed(2),
          ],
          name: element[0],
          //   label: {
          //     show: false,
          //     formatter: function (params) {
          //       return parseFloat(params.value).toFixed(2);
          //     },
          //   },
        });
      });

      let option = {
        title: {
          text: time + name + "污染物雷达图",
          left: "center",
          top: 15,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          //   data: ["预算分配（Allocated Budget）", "实际开销（Actual Spending）"],
          bottom: "20",
          left: "center",
        },
        radar: {
          // shape: 'circle',
          //   "PM2.5", PM10, SO2, NO2, CO, O3
          indicator: [
            { name: "PM2.5(ug/m3)" },
            { name: "PM10(ug/m3)" },
            { name: "SO2(ug/m3)" },
            { name: "NO2(ug/m3)" },
            { name: "CO(mg/m3)" },
            { name: "O3(ug/m3)" },
          ],
          radius: 140,
          name: {
            textStyle: {
              color: "#000",
              //   backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: 3,
              padding: [10, 5],
            },
          },
        },
        series: [
          {
            type: "radar",
            // areaStyle: {},
            data: showdata,
          },
        ],
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },

    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getPullRadarData();
    },

    assessYearChange() {
      //   this.chart_line_data = [];
      // this.assessYear = this.assessYear.getFullYear() + "";
      this.chart_radar_data_raw = [];
      this.chart_radar_data_adm = [];
      this.updateCharts();
    },
    assessSeasonChange() {
      //   this.chart_line_data = [];
      this.chart_radar_data_raw = [];
      this.chart_radar_data_adm = [];
      this.updateCharts();
    },
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(
            document.getElementById("city-pull-radar-adm-chart")
          )
        );

        this.chart.push(
          this.$echarts.init(
            document.getElementById("city-pull-radar-raw-chart")
          )
        );

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("city-pull-radar-adm-chart"))
      );

      this.chart.push(
        this.$echarts.init(document.getElementById("city-pull-radar-raw-chart"))
      );

      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.updateCharts();
    }
    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
};
</script>
